import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "r-arr-right",
  "use": "r-arr-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"r-arr-right\">\n<path d=\"M8.21967 19.7803C7.92678 19.4874 7.92678 19.0126 8.21967 18.7197L14.9393 12L8.21967 5.2803C7.92678 4.9874 7.92678 4.5126 8.21967 4.2197C8.51256 3.9268 8.98744 3.9268 9.28033 4.2197L16.5303 11.4697C16.8232 11.7626 16.8232 12.2374 16.5303 12.5303L9.28033 19.7803C8.98744 20.0732 8.51256 20.0732 8.21967 19.7803Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol